module.exports = __webpack_public_path__ + "static/img/2.e0af719.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/2.png
// module id = lRJ3
// module chunks = 0